import {mapFirestoreDocWithTimestamp, seedQuestionSchema, type SeedQuestion} from '@cp/model';
import type {DocumentSnapshot} from 'firebase/firestore';
import type {SeedQuestionDoc} from './getSeedQuestionCollectionRef';

export default function mapSeedQuestionDoc(doc: DocumentSnapshot<SeedQuestionDoc>): SeedQuestion | undefined {
  const mapped = mapFirestoreDocWithTimestamp(doc);
  if (!mapped) return undefined;
  return seedQuestionSchema.parse({...mapped, id: doc.id});
}
